import React from 'react';

import { Space } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { ArticlePreloader } from '../../../MaterialContent/components/ArticlePreloader';

interface Props {
  isLoading?: boolean;
  color?: React.ComponentProps<typeof ArticlePreloader>['color'];
  withImage?: boolean;
}

export const Preloader: React.FC<Props> = ({ isLoading, color, withImage }) => {
  const isMobile = useIsMobile();

  return (
    <div style={{ display: isLoading ? 'block' : 'none' }} className={'h-mt-24 h-mb-24'}>
      <Space size={20}>
        <ArticlePreloader short color={color} withImage={withImage} />
        {!isMobile && <ArticlePreloader short color={color} withImage={withImage} />}
      </Space>
    </div>
  );
};
